import { IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';

export default (product: IBackboneProduct, mealsArray: number[]):boolean => {
    const mealTypesExtended:{[key: number]: number[]} = {
        1: [1, 8, 11],
        2: [2, 12, 13, 15, 9],
        3: [3, 4, 17],
        5: [5, 6, 16],
        7: [7, 14],
        8: [8],
        10: [10],
        11: [11],
    };
    const extendedMealsArray: number[] = [];
    mealsArray.forEach((mealsType) => {
        if (mealTypesExtended[mealsType]) {
            extendedMealsArray.push(...mealTypesExtended[mealsType]);
        }
    });

    return (extendedMealsArray && extendedMealsArray.length ? !!~extendedMealsArray.indexOf(product.get('product')?.get('meal')?.id) : true);
};